<template>
    <el-tabs type="border-card" :stretch="true">
        <el-tab-pane label="Base Info">
            <el-form label-width="150px" class="detail">
                <el-form-item label="Adv. Id" >
                    <div>{{result.adv_id}}</div>
                </el-form-item>
                <el-form-item label="Adv. Name"  >
                    <div>{{result.adv_name}}</div>
                </el-form-item>
                <el-form-item label="Adv. Type"  >
                    <div>{{result.adv_type}}</div>
                </el-form-item>
                <el-form-item label="Account Level"  >
                    <div>{{'Level ' + (result.account_level&&result.account_level.toUpperCase())}}</div>
                </el-form-item>
                <el-form-item label="Status"  >
                    <div :class="'status-'+result.status">{{result.status&&result.status.toUpperCase()}}</div>
                </el-form-item>
                <el-form-item label="Client Finance Email"  >
                    <div>{{result.client_finance_email}}</div>
                </el-form-item>
                <el-form-item label="Client Dashboard"  >
                    <a :href="result.client_dashboard_addr" target="_blank">{{result.client_dashboard_addr}}</a>
                </el-form-item>
                <el-form-item label="Insertion Order(IO)"  >
                    <div :class="result.io_file?'status-active':'status-paused'">{{result.io_file==null?"Unsigned":"Signed"}}</div>
                </el-form-item>
                <el-form-item label="Remark"  >
                    <div  class="show-new-line">{{result.remark}}</div>
                </el-form-item>
                <el-form-item label="Billing Info"  >
                    <div  class="show-new-line">{{result.billing_info}}</div>
                </el-form-item>
            </el-form>
        </el-tab-pane>
        <el-tab-pane label="Tracking Info">
            <el-form label-width="150px" class="detail">
                <el-form-item label="API Source" >
                    <div :class="result.is_api==1?'status-active':'status-paused'">{{result.is_api==1?"YES":"NO"}}</div>
                </el-form-item>
                <el-form-item label="API Url">
                    <div v-for="(url,key) in api_url" :key="key">
                    <span>{{key + ":"}}</span>
                    <a :href="url" target="_blank">
                        {{url}}
                    </a>
                    </div>
                </el-form-item>
                <el-form-item label="Click Parameters" >
                    <div>{{result.click_parameters}}</div>
                </el-form-item>
                <el-form-item label="Tracking Domain" >
                    <div>{{result.tracking_domain}}</div>
                </el-form-item>
                <el-form-item label="Postback" >
                    <div>{{result.postback}}</div>
                </el-form-item>
                 <el-form-item label="Event Pb" >
                    <div>{{result.event_pb}}</div>
                </el-form-item>
                <el-form-item label="Redirect Model" >
                    <div>{{result.jump_way === 2? "302":"Double meta refresh"}}</div>
                </el-form-item>
                <el-form-item label="Creator" >
                    <div>{{result.creator}}</div>
                </el-form-item>
                <el-form-item label="Create Time" >
                    <div>{{result.createdAt}}</div>
                </el-form-item>
                <el-form-item label="Update Time" >
                    <div>{{result.updatedAt}}</div>
                </el-form-item>
            </el-form>
        </el-tab-pane>
    </el-tabs>
</template>
<script>
export default {
	data() {
		return {
			result: {},
			api_url:{},
		};
	},
	methods:{
		async loaddata(v){
			this.result = await this.$post('/advertiser/detail',{adv_id:v});
			this.api_url = JSON.parse(this.result.api_url);
		}
	},
	props: ["id"],
	watch: {
		id(v) {
			this.loaddata(v);
		}
	},
	mounted(){
		this.loaddata(this.id);
	}
};
</script>


<style scoped>
.el-form-item {
    /* margin:0 10px 0 10px; */
    width: 100%;
    border-style: solid;
    border-color:rgb(230,230,230);
    border-width: 0px 0px 1px 0px;
}
.detail {
    word-wrap:break-word;
}
</style>
